// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3wuVt","label":"LabeledBox_label__1JrMO"};